import type {
  ChoiceResult,
  IdentifiedChoiceResult,
} from '@core-api/presentation/types/response';
import type { Choice } from '../types';

/**
 * Creates the identified results data from the API results
 *
 * @param results - The results data to transform
 * @param choices - The choices for the current slide
 * @returns The identified results data
 */
export function createIdentifiedResults({
  results,
  choices,
}: {
  results: ChoiceResult[] | null | undefined;
  choices: Choice[];
}): IdentifiedChoiceResult[] | null {
  if (!results) {
    return null;
  }

  return results
    .filter((result) => result.legacyChoiceId !== null)
    .map((result) => ({
      choiceId: result.legacyChoiceId!,
      label: choices.find((c) => c.id === result.legacyChoiceId)?.label ?? '',
      responseCount: result.responseCount,
      participants:
        result.participantIdentities?.map((p) => ({
          id: p.id,
          name: p.displayName,
          displayName: p.displayName,
        })) ?? [],
    }));
}
